import React from "react";

import "./Home.css";

import Product from "./Product";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__image"
          src="img/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
          alt="Hero"
        />
      </div>

      <div className="home__row">
        <Product
          id="12343243"
          title="The Lean Startup: How Today's Entrepreneurs Use Continuous Innovation to Create Radically Successful Businesses - Paperback"
          price={29.99}
          image="img/leanstartup.jpeg"
          rating={5}
        />
        <Product
          id="49538094"
          title="Kenwood kMix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre GLass Bowl"
          price={239.0}
          rating={4}
          image="img/kenwoodmixer.jpg"
        />
      </div>
      <div className="home__row">
        <Product
          id="98741234"
          title="Fitbit Charge 5 Advanced Fitness & Health Tracker with Built-in GPS"
          price={179.95}
          rating={4}
          image="img/fitbit.jpg"
        />
        <Product
          id="59275921"
          title="Echo Dot (3rd Gen) Charcoal with Mandalorian The Child stand"
          price={49.94}
          rating={5}
          image="img/echoears.jpg"
        />
        <Product
          id="4924958"
          title="2021 Apple 11-inch iPad Pro (Wi-Fi, 256GB) - Space Gray"
          price={849.99}
          rating={5}
          image="img/ipadpro.jpg"
        />
      </div>
      <div className="home__row">
        <Product
          id="57891368"
          title='Samsung - Odyssey G9 49" LED UltraWide Curved QHD FreeSync and G-SYNC Compatible Monitor with HDR - Black/White'
          price={1149.99}
          rating={5}
          image="img/samsungmonitor.jpeg"
        />
      </div>
    </div>
  );
}

export default Home;
